export class AuthData {
    constructor (public id:String, public role:String, public name:String, public email:String) {

    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/data/auth-data.ts